interface QuizViewBannedProps {
  message: string;
}

export const QuizViewBanned = ({ message }: QuizViewBannedProps) => {
  return (
    <div
      key="view-banned"
      class="flex flex-col items-center justify-center h-screen bg-base-200 px-4 space-y-6"
    >
      <div class="text-center space-y-2">
        <h2 class="text-6xl font-black text-error tracking-tighter uppercase">
          BANNED
        </h2>
        <p class="opacity-60 font-bold italic max-w-md">{message}</p>
      </div>
      <a href="/quiz" class="btn btn-ghost font-black">Back to Lobby</a>
    </div>
  );
};
